import { useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import {
  currencyFormatWithoutDecimalV1,
  getPercentageWithAlertV2,
} from "../../helpers/api_helper";
import "../../assets/scss/config/default/StatWidgetCard.scss";
import Loader from "../../Components/Common/Loader";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { NEWDISCOUNT } from "../../helpers/data_helper";

const OverallWidget = ({ mealPeriod, leftFilter, discountCodes, serveList, currency }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [widgetData, setWidgetData] = useState()
  const [loading, setLoading] = useState(true);
  const [discountedItems, setDisCountedItems] = useState([])
  const tableRef = useRef(null); // for scroll container div

  const PAGE_SIZE = 50
  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    // if (!hasMore) return;
    setLoading(true);
    const controller = new AbortController(); 
    postDataAPI({
      serviceName: NEWDISCOUNT.serviceName,
      op: NEWDISCOUNT.op_discount_dashboard_widget,
      leftFilter: leftFilter,
      mealPeriod: mealPeriod,
      page: page,
      server_id: serveList,
      discount_id: discountCodes,
    }, controller.signal).then((response) => {
      setLoading(false);

      const newItems = response?.data?.data?.item_list || []

      if (newItems.length < PAGE_SIZE) {
        setHasMore(false);
      }

      if (page === 0) {
        setWidgetData(response?.data?.data);
        setDisCountedItems(newItems);
      } else {
        setDisCountedItems((prev) => [...prev, ...newItems]);
      }
    }).catch(() => {
      setLoading(false);
    });
    return () => {
        controller.abort();
    };
  }, [page, mealPeriod, leftFilter, discountCodes, serveList]);




  useEffect(() => {
    // if (page === 0) return;
    setPage(0);       // ✅ Reset pagination
    setHasMore(true); // ✅ Allow more scroll
    setLoading(true);
  }, [mealPeriod, leftFilter, discountCodes, serveList]);


  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 1 && hasMore && !loading) {
      setPage((prev) => prev + 1);
    }
  };

  const showSectionLoader = !isOpen && (loading || !widgetData);

  return (
    <>
      <div
        className="position-relative mb-4"
        style={{ minHeight: showSectionLoader ? 200 : undefined }}
      >
        {showSectionLoader && <Loader />}
        <div className={showSectionLoader ? "opacity-0" : ""}>
        
        <Col xl={12}>          
            <div className="mb-3">
            <div className={`p-0 row g-3`}>
            <Col xs={12} lg={6} className="ps-0 pe-0 pe-lg-2 ct-mt_1_5">
              <Card className="stat-widget-car h-100">
                <CardBody className="text-wrap" style={{ paddingInline: '0.75rem' }}>
                  <div className="d-flex mb-3">
                    <div className="me-3">
                      <div className={`icon-box rounded  bg-secondary text-white`}>
                        {currency}
                      </div>
                    </div>
                    <div className="w-100">
                      <h6 className="fs-20 mb-2">Total Discounts Given</h6>
                      <div>
                        <h2 className="fw-bold mb-0 d-inline">
                          {currencyFormatWithoutDecimalV1(widgetData?.no_rows_discounted, '')}
                        </h2>
                        <p className="mb-0 px-2 fs-14 d-inline text-break">
                          out of {currencyFormatWithoutDecimalV1(widgetData?.tot_no_rows, '')} transactions
                        </p>
                      </div>
                    </div>
                  </div>
                  <Row className="small fs-14 g-3">
                    <Col xs={12} sm className="text-break">
                      {getPercentageWithAlertV2(widgetData?.lastmonth_discont_variance_percentage)} vs. Same time Last month
                    </Col>
                    <Col xs={12} sm className="text-sm-end text-break">
                      Last month total: {currencyFormatWithoutDecimalV1(widgetData?.lastmonth_tot_no_rows, '')} transactions
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} lg={6} className="ps-0 pe-0 ps-lg-2">
              <Card className="stat-widget-car h-100">
                <CardBody className="text-wrap" style={{ paddingInline: '0.75rem' }}>
                  <div className="d-flex mb-3">
                    <div className="me-3">
                      <div className={`icon-box rounded  bg-success text-white`}>
                        {currency}
                      </div>
                    </div>
                    <div className="w-100">
                      <h6 className="fs-20 mb-2">Total Revenue Discounted</h6>
                      <div>
                        <h2 className="fw-bold mb-0 d-inline">
                          {currencyFormatWithoutDecimalV1(widgetData?.total_discounted_amt, currency)}
                        </h2>
                        <p className="mb-0 px-2 fs-14 d-inline text-break">
                          out of {currencyFormatWithoutDecimalV1(Number(widgetData?.total_rev_amt).toFixed(0), currency)} total revenue
                        </p>
                      </div>
                    </div>
                  </div>
                  <Row className="small fs-14 g-3">
                    <Col xs={12} sm className="text-break">
                      Avg. discount: {currencyFormatWithoutDecimalV1(widgetData?.avg_discount, currency)}
                    </Col>
                    <Col xs={12} sm className="text-sm-end text-break">
                      Last month: {currencyFormatWithoutDecimalV1(widgetData?.lastmonth_avg_discount, currency)}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>  
            </div>          
            </div>
         </Col> 
        <Col xl={12} className="mt-4">
        
        <Row className="g-3">   
          
          <Card className="mb-0">
            <CardHeader className="ps-0 border-0 d-flex justify-content-between align-items-center ">
              <div className="d-flex align-items-start">
                <div className={`icon-box rounded bg-danger text-white`}>
                  <i className="ri-award-line"></i>
                </div>
                <div className="ps-2">
                  <h4 className="card-title mb-1">
                    Top 3 Most Discounted Items
                  </h4>
                  <p className="text-muted mb-0">
                    Items with the highest discount frequency
                  </p>
                </div>
              </div>
            </CardHeader>
            <CardBody className={`p-0 row g-3 ${discountedItems?.length === 0 ? "opacity-0" : ''}`} >
              {discountedItems.slice(0, 3)?.map((item, index) =>
                <Col xl={4} key={index}>
                  <Card
                    className="stat-widget-card custom-hover-card-discount cursor-pointer"
                    style={{ border: "1px solid #ffe3e3" }}
                    onClick={toggle}
                  >
                    <CardBody>
                      <div>
                        <div className="text-center mb-3">
                          <h6 className="mb-1 fw-semibold">{item?.item_name}</h6>
                          <div className="text-muted small">{item?.course}</div>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Times Discounted</span>
                          <span className="text-danger fw-semibold">{item?.times_discounted}x</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Total Discount Value</span>
                          <span className="text-success fw-semibold">{currency}{item?.total_discount_value}</span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )}
            </CardBody>
          </Card>
          
        </Row>
        </Col>
      </div>
      </div>
      <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
        <ModalHeader toggle={toggle}>All Discounted Items</ModalHeader>
        <ModalBody>
          <div style={{ overflow: 'auto', maxHeight: '500px' }} ref={tableRef} onScroll={handleScroll}>
            <Table borderless responsive>
              <thead>
                <tr>
                  <th scope="row" className="text-muted">
                    Item Name
                  </th>
                  <th scope="row" className="text-muted">
                    Course
                  </th>
                  <th scope="row" className="text-muted text-center">
                    Times Discounted
                  </th>
                  <th scope="row" className="text-muted text-center">
                    Total Discount Value
                  </th>
                  <th scope="row" className="text-muted text-center">
                    Avg. Discount Value
                  </th>
                </tr>
              </thead>
              <tbody>
                {discountedItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.item_name}</td>
                    <td className="text-muted q">{item.course}</td>
                    <td className="text-center" style={{ color: "red" }}>
                      {item.times_discounted}
                    </td>
                    <td className="text-center" style={{ color: "teal" }}>
                      {item.total_discount_value}
                    </td>
                    <td className="text-center" style={{ color: "teal" }}>
                      {parseInt(item?.times_discounted) !== 0 ? Number(parseInt(item.total_discount_value, 10) / parseInt(item?.times_discounted)).toFixed(2) : 0}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {loading && (
              <Loader />
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default OverallWidget;
